import type { ComponentPropsWithoutRef, ReactNode } from "react";

export type TextInputItemProps = {
	title: ReactNode;
	type?: "text" | "number";
	error?: string;
} & Omit<ComponentPropsWithoutRef<"input">, "type">;

export const TextInputItem = ({
	title,
	type = "text",
	className = "field-item__input",
	error,
	...inputProps
}: TextInputItemProps) => {
	const { onWheel, ...restInputProps } = inputProps;
	return (
		<div className='form__fields_field-item field-item'>
			<div className='field-item__title'>{title}</div>
			<div className='field-item__input-wrapper'>
				<input
					type={type}
					className={className}
					{...restInputProps}
					onWheel={(e) => {
						if (type === "number") {
							e.currentTarget.blur();
						}
						onWheel?.(e);
					}}
				/>
			</div>
			{error && <div className='field-item__error'>{error}</div>}
		</div>
	);
};
